import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Form,
  Modal,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  TabPane,
  TabContent,
  Nav,
  NavItem,
  NavLink,
  Badge,
  Label,
  Input,
} from "reactstrap";
import classnames from "classnames";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Pagi2 from "common/utils/Pagi2";
import { CommonTableContainer } from "common/utils/ComonTableContainer";
import "../../common/styles/leads.css";
import configure from "configure";
import axios from "axios";
import Loader from "components/Common/Loader";
import AccessDeniedPopup from "components/Common/AccessDeniedPopup";
import { icon } from "leaflet";
import Swal from "sweetalert2";
import { method } from "lodash";
import secureLocalStorage from "react-secure-storage";
import ViewLead from "./ViewLead";
import EditLead from "./EditLead";
import ViewNote from "./ViewNote";
import ViewFollowUp from "./ViewFollowup";
import AddNotes from "./Notes";
import Addfollowups from "./Followup";
import { Tooltip } from "antd";
import Pagination from "common/utils/Pagination";
import { customGlobalFilter } from "utils/common-helpers";
import { colourStyles } from "common/utils/ComonOptions";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import Select from "react-select";
import { type } from "utils/common-options";

const LeadIndex = () => {
  const [modal_fullscreen, setmodal_fullscreen] = useState(false);
  const [verticalActiveTab, setverticalActiveTab] = useState("1");
  const [fixedContent, setFixedContent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [auth_id, setAuth_id] = useState(null);
  const [fixedSideTab, setFixedSideTab] = useState(false);
  const [modal_fullscreen1, setmodal_fullscreen1] = useState(false);
  const [verticalActiveTab1, setverticalActiveTab1] = useState("1");
  const [Leadid, setleadid] = useState(null);
  const [LeadStatus, setLeadStatus] = useState([])

  const toggleVertical = (tab) => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab);
    }
  };

  useEffect(() => {
    const authUser = secureLocalStorage.getItem("User");
    setAuth_id(authUser.uid);
    fetchstatus();
  }, []);
  // console.log("authIDD", auth_id)

  const fetch = async () => {
    setLoading(true);
    const token = secureLocalStorage.getItem("Token");
    try {
      const resp = await axios({
        method: "GET",
        url: `${configure.apiUrl}/leads`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setData(resp.data.leads);
      setAllData(resp.data.leads);
      setLoading(false);
      // console.log("leads - resp", resp)
    } catch (err) {
      console.log("leads - error", err);
      setLoading(false);
    }
  };

  const fetchstatus = async () => {
    setLoading(true);
    const token = secureLocalStorage.getItem("Token");
    try {
      const resp = await axios({
        method: "GET",
        url: `${configure.apiUrl}/leads/all/status`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLeadStatus(resp.data.status.map((item) => ({
        label: item.name,
        value: item.id,
        ...item
      })))

      setLoading(false);
    } catch (err) {
      console.log("leads - error", err);
      setLoading(false);
    } finally {
      fetch();
    }
  };

  document.title = "Leads | Zithas Technologies";

  const navigate = useNavigate();

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true);
    } else {
      setFixedContent(false);
    }
  });

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lead_id",
        Cell: (cellProps) => {
          return <div className="">{cellProps.row.original.id}</div>;
        },
      },

      {
        Header: "Company",
        accessor: "company",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lead_company",
        Cell: cellProps => {
          return (
            <div className="d-flex justify-content-between align-items-center">
              <Tooltip color={"#752b97"} title={`Service : ${cellProps.row.original?.service != null ? cellProps.row.original?.service : 'Not Defined'}`}>
                <div>
                  {cellProps.row.original.company !== null
                    ? cellProps.row.original.company
                    : "-"}
                </div>
              </Tooltip>
              <div>
                {cellProps.row.original.lead_type == "Hot" ? (
                  <i
                    className="bx bxs-hot"
                    style={{
                      fontSize: "18px",
                      lineHeight: "0",
                      color: "#FF5733",
                    }}
                  ></i>
                ) : cellProps.row.original.lead_type == "Warm" ? (
                  <i
                    className="bx bxs-flame"
                    style={{
                      fontSize: "20px",
                      lineHeight: "0",
                      color: "#fdab99",
                    }}
                  ></i>
                ) : cellProps.row.original.lead_type == "Cold" ? (
                  <i
                    className="bx bxs-sun"
                    style={{
                      fontSize: "20px",
                      lineHeight: "0",
                      color: "#4ab3ff",
                    }}
                  ></i>
                ) : cellProps.row.original.lead_type == "Extreme Hot" ? (
                  <i
                    className="mdi mdi-fire-alert"
                    style={{
                      fontSize: "20px",
                      lineHeight: "0",
                      color: "#ff0000ff",
                    }}
                  ></i>
                ) : null}
              </div>
            </div>
          )
        },
      },

      {
        Header: "Name",
        accessor: "person_details",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lead_name",
        Cell: cellProps => {
          const personal = JSON.parse(cellProps.row.original.person_details)
          let PersonName
          if (personal != null && personal?.length == 0) {
            PersonName = "-"
          } else if (personal != null) {
            PersonName = personal[0]?.person_name
          }
          return <div>{PersonName ? PersonName : "-"}</div>
        },
      },
      {
        Header: "Email",
        accessor: "email",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lead_email",
        Cell: cellProps => {
          const alldata = cellProps.row.original
          return (
            <div>
              {alldata?.person_details
                ? JSON.parse(alldata.person_details)[0]?.person_email
                  ? JSON.parse(alldata.person_details)[0].person_email
                  : alldata?.email != null
                    ? alldata?.email
                    : "-"
                : alldata?.email != null
                  ? alldata?.email
                  : "-"}
            </div>
          )
        },
      },
      {
        Header: "Phone",
        accessor: "phone",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lead_phone",
        Cell: cellProps => {
          const alldata = cellProps.row.original
          return (
            <div>
              {alldata?.person_details
                ? JSON.parse(alldata.person_details)[0]?.person_phone
                  ? JSON.parse(alldata.person_details)[0].person_phone
                  : alldata?.phonenumber != null
                    ? alldata?.phonenumber
                    : "-"
                : alldata?.phonenumber != null
                  ? alldata?.phonenumber
                  : "-"}
            </div>
          )
        },
      },
      {
        Header: "Days",
        accessor: "diff",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lead_days",
        Cell: (cellProps) => {
          const dateAdded = new Date(cellProps.row.original.dateadded);
          const now = new Date();
          const diffMs = now - dateAdded;
          const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

          return <div className="text-center">{diffDays}</div>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        isInfoIcon: false,
        isShortIcon: true,
        className: "lead_status text-center",
        Cell: (cellProps) => {
          const Status = LeadStatus?.find(
            (item) => item.value == cellProps.row.original.status
          );
          return <Badge className={Status?.color}>
            {Status?.label}
          </Badge>;
        },
      },

      {
        Header: "Action",
        accessor: "action",
        className: "lead_action",
        isInfoIcon: false,
        Cell: (cellProps) => {
          // Delete Lead Function
          const onDeleteLead = async (e) => {
            Swal.fire({
              title: "Are you sure?",
              text: "You want to delete this Lead!",
              icon: "warning",
              showCancelButton: true,
              cancelButtonText: "No, cancel",
              confirmButtonText: "Yes, delete it!",
              dangerMode: true,
            }).then(async (result) => {
              if (result.isConfirmed) {
                setLoading(true);

                const token = secureLocalStorage.getItem("Token");
                try {
                  const response = await axios({
                    method: "delete",
                    url: `${configure.apiUrl}/leads/${cellProps.row.original.id}`,
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });

                  // Show success alert
                  setLoading(false);
                  await Swal.fire({
                    icon: "success",
                    text: "Lead Deleted Successfully",
                  });
                  fetch();
                } catch (err) {
                  setLoading(false);
                  Swal.fire({
                    icon: "error",
                    title: "Lead Delete Cancelled",
                  });
                } finally {
                  setLoading(false);
                }
              }
            });
          };
          return (
            <>
              <div className="d-flex justify-content-center">
                <Link
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="Edit Lead"
                  to={`#`}
                  onClick={() => {
                    setleadid(cellProps.row.original.id),
                      setmodal_fullscreen1(true);
                  }}
                >
                  <i className="fas fa-pen "></i>
                </Link>
                <Link
                  to={`#`}
                  onClick={() => {
                    setleadid(cellProps.row.original.id),
                      setmodal_fullscreen(true);
                  }}
                  className="btn btn-sm btn-outline-secondary me-1"
                  title="View Lead"
                >
                  <i className="fas fa-eye "></i>
                </Link>

                <UncontrolledDropdown
                  className="dropdown"
                  style={{ width: "29px" }}
                >
                  <DropdownToggle
                    className="btn btn-sm btn-outline-secondary w-100"
                    color="white"
                  >
                    <i className="mdi mdi-dots-horizontal"></i>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <a
                      title="Delete Lead"
                      className="dropdown-item"
                      onClick={onDeleteLead}
                    >
                      <i className="fas fa-trash-alt text-danger pr-10 me-2"></i>{" "}
                      Delete Lead
                    </a>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </>
          );
        },
      },
    ],
    [LeadStatus]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalFilter,
      initialState: {
        pageIndex: 0,
        sortBy: [{ id: "id", desc: true }],
      },
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state;
  useEffect(() => setPageSize(50), []);
  const [formPopup, setFormPopup] = useState(false);
  const [sourceFilter, setSourceFilter] = useState([])
  const [statusFilter, setStatusFilter] = useState([])
  const [typeFilter, setTypeFilter] = useState([])
  const [industryFilter, setIndustryFilter] = useState([])
  const [sourceOption, setSourceOption] = useState([])
  const [industryOption, setIndustryOption] = useState([])

  const onOpenFilter = async () => {
    await axios({
      method: "get",
      url: `${configure.api}/filter_data`,
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    }).then((ress) => {
      setSourceOption(ress?.data?.data?.india_source?.map((obj) => ({
        value: obj?.id,
        label: obj?.leadname
      })))
      setIndustryOption(ress?.data?.data?.industry?.map((obj) => ({
        value: obj?.id,
        label: obj?.name
      })))
      setFormPopup(true)
    })
  }
  const filterData = (data, filters) => {
    return data.filter(item => {
      const matchIndustry = !filters.industry || filters.industry?.length === 0 || filters.industry.value == item.industry;
      const matchStatus = !filters.status || filters.status?.length === 0 || filters.status.value == item.status;
      const matchSource = !filters.source || filters.source?.length === 0 || filters.source.value == item.source;
      const matchType = !filters.type || filters.type?.length === 0 || filters.type.label?.toLowerCase() == item.lead_type?.toLowerCase();

      return matchIndustry && matchStatus && matchSource && matchType;
    });
  };

  const onFilter = () => {
    const datasFilter = {
      industry: industryFilter,      // ID field
      status: statusFilter,       // ID field
      source: sourceFilter,  // ID field
      type: typeFilter
    }

    setData(filterData(allData, datasFilter))
  }

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Lead"} />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <div>
                      {/* fixed buttons */}
                      <div
                        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
                          }`}
                      >
                        <Link
                          onClick={() =>
                            navigate(`${configure.appUrl}/add-lead`)
                          }
                          className=" btn ms-md-2 btn-save btn-label"
                        >
                          <i className="fas fa-plus me-1 label-icon"></i> Lead
                        </Link>
                        <button
                          onClick={() => navigate(-1)}
                          className="btn btn-red  fix-btn btn-label"
                        >
                          <i className="dripicons-cross me-2 icon-center label-icon"></i>
                          <span>Cancel</span>
                        </button>
                      </div>
                      <Row className="mb-2 align-items-center">
                        <Col className="col-6 d-flex gap-2 align-items-center">
                          <select
                            className=" me-4 form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={(e) => setPageSize(e.target.value)}
                          >
                            {[10, 25, 50, 100].map((pageSize) => (
                              <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                              </option>
                            ))}
                          </select>
                          <div className="d-flex justify-content-start gap-3">
                            <a className="d-flex gap-3 align-items-center general-box ">
                              <h5 className="text-purple mb-0">Hot : </h5>
                              <h5 className="text-primary mb-0">{data?.filter((obj) => obj?.lead_type == 'Hot')?.length}</h5>
                            </a>
                            <a className="d-flex gap-3 align-items-center general-box ">
                              <h5 className="text-purple mb-0">Warm : </h5>
                              <h5 className="text-primary mb-0">{data?.filter((obj) => obj?.lead_type == 'Warm')?.length}</h5>
                            </a>
                            <a className="d-flex gap-3 align-items-center general-box ">
                              <h5 className="text-purple mb-0">Cold : </h5>
                              <h5 className="text-primary mb-0">{data?.filter((obj) => obj?.lead_type == 'Cold')?.length}</h5>
                            </a>
                            <a className="d-flex gap-3 align-items-center general-box ">
                              <h5 className="text-purple mb-0">Normal : </h5>
                              <h5 className="text-primary mb-0">{data?.filter((obj) => obj?.lead_type == 'Normal')?.length}</h5>
                            </a>
                          </div>

                        </Col>
                        <Col className="col-6 d-flex justify-content-end align-items-center ">
                          <button type="button" className="btn btn-outline-secondary me-2" onClick={() => {
                            onOpenFilter()
                          }}>
                            <i className="fas fa-filter"></i>
                          </button>
                          <div className="me-2">
                            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
                              <div className="position-relative">
                                <label
                                  htmlFor="search-bar-0"
                                  className="search-label mb-0"
                                >
                                  <span
                                    id="search-bar-0-label"
                                    className="sr-only"
                                  >
                                    Search this table
                                  </span>
                                  <input
                                    onChange={e => setGlobalFilter(e.target.value)}
                                    id="search-bar-0"
                                    type="text"
                                    className=" form-control rounded h-100"
                                    placeholder={` Search...`}
                                    value={globalFilter || ""}
                                  />
                                </label>
                                <i className="bx bx-search-alt search-icon"></i>
                              </div>
                            </div>
                          </div>
                          <div className="text-md-end">

                            <Link
                              //  to={`${configure.appUrl}/add-lead`}
                              to={`${configure.appUrl}/add-lead`}
                              className=" btn ms-md-2 btn-save  btn-label me-2"
                            >
                              <i className="fas fa-plus me-1 label-icon"></i>{" "}
                              Lead
                            </Link>
                            <button
                              onClick={() => navigate(-1)}
                              className=" btn btn-red btn-label"
                            >
                              <i className="dripicons-cross me-2  lab label-icon"></i>
                              CANCEL
                            </button>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div className="col-12">
                          <div className="position-relative shadow">
                            <table
                              className="table table-bordered mt-4"
                              {...getTableProps()}
                            >
                              <thead
                                className={`${fixedContent ? "fix-header" : ""
                                  } fix-lead-header`}
                              >
                                {headerGroups.map((headerGroup, i) => (
                                  <tr
                                    key={i}
                                    {...headerGroup.getHeaderGroupProps()}
                                  >
                                    {headerGroup.headers.map((column, index) => (
                                      <th
                                        key={index}
                                        className={`t-col-${index + 1} ${column.className
                                          }`}
                                        {...column.getHeaderProps()}
                                      >
                                        {column.render("Header")}
                                      </th>
                                    ))}
                                  </tr>
                                ))}
                              </thead>

                              <tbody
                                className="fix-lead-header"
                                {...getTableBodyProps()}
                              >
                                {page.map((row, i) => {
                                  prepareRow(row)
                                  let backColor
                                  if (row.original.lead_type == "Hot") {
                                    backColor = "bd-hot"
                                  }
                                  return (
                                    <tr
                                      className={`row-hover ${backColor}`}
                                      {...row.getRowProps()}
                                      key={i}
                                    >
                                      {row.cells.map((cell, index) => {
                                        return (
                                          <td
                                            key={index}

                                            className={`t-col-${index + 1} ${cell.column.className
                                              }`}
                                            {...cell.getCellProps()}
                                          >
                                            {cell.render("Cell")}
                                          </td>
                                        )
                                      })}
                                    </tr>
                                  )
                                })}
                                {page.length == 0 ? (
                                  <tr>
                                    <td className="text-center" colSpan={10}>
                                      No Leads Available
                                    </td>
                                  </tr>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Row>

                      {/* Pagination */}
                      <Row className="justify-content-md-end justify-content-center align-items-center">
                        <Pagination
                          gotoPage={gotoPage}
                          previousPage={previousPage}
                          canPreviousPage={canPreviousPage}
                          nextPage={nextPage}
                          canNextPage={canNextPage}
                          pageIndex={pageIndex}
                          pageOptions={pageOptions}
                        />
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal size="xl" isOpen={modal_fullscreen} className="modal-fullscreen">
          <div className="modal-header mb-0">
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ width: "100%" }}
            >
              <h5 className="col-6 modal-title mt-0">Lead Details</h5>
            </div>

            <button
              type="button"
              onClick={() => {
                setmodal_fullscreen(false);
              }}
              className="ms-4"
              style={{
                border: "none",
                backgroundColor: "transparent",
              }}
            >
              <span
                aria-hidden="true"
                style={{
                  color: "#bf1e30",
                  fontSize: "28px",
                  lineHeight: "1px",
                }}
              >
                {" "}
                &times;{" "}
              </span>
            </button>
          </div>

          <div className="modal-body hide-bottom-scrollbar  pe-0 pt-0">
            <Row className="gx-4 justify-content-between ">
              <Col md="2" className="px-0">
                <Nav
                  pills
                  className={`side-tab flex-column px-2 py-3 bg-white  ${fixedSideTab ? "fixed-side-tab" : ""
                    } h-100`}
                >
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "1",
                      })}
                      onClick={() => {
                        toggleVertical("1");
                      }}
                    >
                      Lead Details
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "2",
                      })}
                      onClick={() => {
                        toggleVertical("2");
                      }}
                    >
                      Notes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "3",
                      })}
                      onClick={() => {
                        toggleVertical("3");
                      }}
                    >
                      Follow Up
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>

              <Col md="10" className="bd-right-side-tab">
                <div className="px-4 h-100 pl-0">
                  <TabContent
                    activeTab={verticalActiveTab}
                    className="text-muted mt-4 mt-md-0"
                  >
                    <TabPane tabId="1">
                      <ViewLead id={Leadid} LeadStatus={LeadStatus} />
                    </TabPane>
                    <TabPane tabId="2">
                      <ViewNote id={Leadid} />
                    </TabPane>
                    <TabPane tabId="3">
                      <ViewFollowUp id={Leadid} />
                    </TabPane>
                  </TabContent>
                </div>
              </Col>
            </Row>
          </div>
        </Modal>

        <Modal
          size="xl"
          isOpen={modal_fullscreen1}
          className="modal-fullscreen"
        >
          <div className="modal-header mb-0">
            <div
              className="d-flex align-items-center justify-content-between"
              style={{ width: "100%" }}
            >
              <h5 className="col-6 modal-title mt-0">Edit Lead Details</h5>
            </div>

            <button
              type="button"
              onClick={() => {
                setmodal_fullscreen1(false);
              }}
              className="ms-4"
              style={{
                border: "none",
                backgroundColor: "transparent",
              }}
            >
              <span
                aria-hidden="true"
                style={{
                  color: "#bf1e30",
                  fontSize: "28px",
                  lineHeight: "1px",
                }}
              >
                {" "}
                &times;{" "}
              </span>
            </button>
          </div>

          <div className="modal-body hide-bottom-scrollbar  pe-0 pt-0">
            <Row className="gx-4 justify-content-between ">
              <Col md="2" className="px-0">
                <Nav
                  pills
                  className={`side-tab flex-column px-2 py-3 bg-white  ${fixedSideTab ? "fixed-side-tab" : ""
                    } h-100`}
                >
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "1",
                      })}
                      onClick={() => {
                        toggleVertical("1");
                      }}
                    >
                      Lead Details
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "2",
                      })}
                      onClick={() => {
                        toggleVertical("2");
                      }}
                    >
                      Notes
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        "mb-2": true,
                        active: verticalActiveTab === "3",
                      })}
                      onClick={() => {
                        toggleVertical("3");
                      }}
                    >
                      Follow Up
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>

              <Col md="10" className="bd-right-side-tab">
                <div className="px-4 h-100 pl-0">
                  <TabContent
                    activeTab={verticalActiveTab}
                    className="text-muted mt-4 mt-md-0"
                  >
                    <TabPane tabId="1">
                      <EditLead
                        id={Leadid}
                        fetch={fetch}
                        setmodal_fullscreen1={setmodal_fullscreen1}
                        LeadStatus={LeadStatus}
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <AddNotes id={Leadid} />
                    </TabPane>
                    <TabPane tabId="3">
                      <Addfollowups id={Leadid} />
                    </TabPane>
                  </TabContent>
                </div>
              </Col>
            </Row>
          </div>
        </Modal>

        {formPopup ? (
          <Draggable>
            <ResizableBox
              width={1300}
              style={{
                position: "fixed",
                top: "30%",
                right: "3%",
                zIndex: "1055",
                backgroundColor: "#fff",
              }}
            >
              <Form
                className="d-flex justify-content-start align-items-center gap-2"
                onSubmit={(e) => e.preventDefault()} // Prevent form submission
              >
                <div className="col-9 d-flex">
                  <div className="col-3 ps-2">
                    <Label htmlFor="formrow-start-date">
                      Status <span className="text-danger">*</span>
                    </Label>
                    <Select
                      placeholder="Select Status"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={LeadStatus}
                      value={statusFilter}
                      onChange={e => setStatusFilter(e)}
                      isClearable
                    />
                  </div>
                  <div className="col-3  ps-2">
                    <Label htmlFor="formrow-end-date">
                      Source <span className="text-danger">*</span>
                    </Label>
                    <Select
                      value={sourceFilter}
                      onChange={e => {
                        setSourceFilter(e)
                      }}
                      placeholder="Select Source"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={sourceOption}
                      isClearable
                    />
                  </div>
                  <div className="col-3 ps-2">
                    <Label htmlFor="formrow-customer">
                      Lead Type  <span className="text-danger">*</span>
                    </Label>
                    <Select
                      value={typeFilter}
                      onChange={e => {
                        setTypeFilter(e)
                      }}
                      placeholder="Select Lead Type"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={type}
                      isClearable
                    />
                  </div>
                  <div className="col-3 ps-2">
                    <Label htmlFor="formrow-customer">
                      Industry  <span className="text-danger">*</span>
                    </Label>
                    <Select
                      value={industryFilter}
                      onChange={e => setIndustryFilter(e)}
                      placeholder="Select Lead Type"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={industryOption}
                      isClearable
                    />
                  </div>
                </div>
                <div className="col-3 mt-4 d-flex justify-content-end align-items-end gap-2">
                  <button
                    type="button" // Prevent form submission
                    className="btn btn-save btn-label me-1"
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default form submission
                      onFilter()
                    }}
                  >
                    <i className="fas fa-filter search-icon label-icon"></i>{" "}
                    Filter
                  </button>
                  <button
                    type="button" // Prevent form submission
                    className="btn btn-red btn-label me-1"
                    onClick={() => {
                      setFormPopup(false);
                    }}
                  >
                    <i className="dripicons-cross label-icon"></i> Close
                  </button>
                  <button
                    type="button" // Prevent form submission
                    className="btn btn-warning btn-label me-1"
                    onClick={() => {
                      setIndustryFilter([])
                      setStatusFilter([])
                      setTypeFilter([])
                      setSourceFilter([])
                      setData(allData)
                    }}
                  >
                    <i className="dripicons-cross label-icon"></i> Clear
                  </button>
                </div>
              </Form>
            </ResizableBox>
          </Draggable>
        ) : null}
      </div>
    </React.Fragment>
  );
};

export default LeadIndex;
